import { useEffect, useRef, useState } from "react";
import { Html5Qrcode } from "html5-qrcode";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { QrCode } from "lucide-react";

const REGION_ID = "qr-reader-region";

export default function CardScanner({ open, onClose, onDetected }) {
  const scannerRef = useRef(null);
  const detectedRef = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!open) return;
    detectedRef.current = false;
    setError("");
    let html5;
    const start = async () => {
      let tries = 0;
      while (!document.getElementById(REGION_ID) && tries < 30) {
        await new Promise((r) => setTimeout(r, 50));
        tries++;
      }
      if (!document.getElementById(REGION_ID)) return;
      html5 = new Html5Qrcode(REGION_ID);
      scannerRef.current = html5;
      try {
        await html5.start(
          { facingMode: "environment" },
          { fps: 10, qrbox: 240 },
          (decodedText) => {
            if (detectedRef.current) return;
            detectedRef.current = true;
            onDetected(decodedText);
          },
          () => {}
        );
      } catch (e) {
        setError("Impossible d'accéder à la caméra. Autorisez la caméra ou saisissez le n° de carte manuellement.");
      }
    };
    start();
    return () => {
      const s = scannerRef.current;
      if (s) {
        s.stop().then(() => s.clear()).catch(() => {});
        scannerRef.current = null;
      }
    };
  }, [open, onDetected]);

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="card-scanner-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2"><QrCode size={20} className="text-sky-600" /> Scanner une carte</DialogTitle>
          <DialogDescription>Placez le QR code de la carte de fidélité devant la caméra.</DialogDescription>
        </DialogHeader>
        <div id={REGION_ID} className="w-full rounded-lg overflow-hidden bg-slate-100 min-h-[240px]" />
        {error && <p className="text-sm text-rose-600" data-testid="scanner-error">{error}</p>}
      </DialogContent>
    </Dialog>
  );
}
